import { model } from '../core/model'

const otrosEnlaces = function (label) {
    pushData({
        'event': 'trackPage',
        'eventCategory': 'paywall',
        'eventAction': model.Window.source, // Indicará según corresponda uno de los siguientes strings: muro  landing pantalla plan insuficiente muro-sin-combo 
        'eventLabel': label // Se indicará según corresponda uno de los siguientes strings: logo header //  volver // mas informacion // mail
    })
}

const clearEcommerce = function () {
    pushData({ "ecommerce": null })
}

const clickCombo = function (price, canalVenta, formaContacto, tieneClub, item) {
    const ecommerce = {
        currency: "ARS",
        value: price,
        flujo_suscripcion: "seleccionar_plan",
        canal_venta: canalVenta,
        forma_contacto: formaContacto,
        tiene_club: tieneClub,
        items: [{
            item_id: item.id,
            item_name: item.name,
            item_category: model.ProductCategory,
            item_category2: item.category, //Nombre de wall
            price: item.price
        }]
    }
    pushData({
        'event': 'trackClickProd',
        'ecommerce': ecommerce
    })
}

const clickCombo3 = function (list) {
    pushData({
        'event': 'trackEvent',
        'eventCategory': 'paywall',
        'eventLabel': 'Continuar sin cargo',
        'eventAction': list
    })
}

const clickYaTengoSuscripcion = function () {
    pushData({
        'event': 'trackEvent',
        'eventCategory': 'Ya tengo suscripcion',
        'eventLabel': 'Ya tengo suscripcion'
    })
}

const trackViewPaywall = function () {
    pushData({
        'event': 'trackViewPaywall',
        'pageName': model.Window.source
    })
}

const paginaVirtual = function (data) {
    pushData({
        'event': 'trackPage',
        'pageName': data.source,  // Pagina actual   
        'checkoutProd': '',
        'formaContacto': data.contact,
        'canalVenta': data.canalVenta
    })
}

//Track de click en el botón 'suscribirme' de las landings
const trackViewLanding = function (name, price) {
    pushData({
        'event': 'trackClickLanding',
        'price': price,
        'landing': name
    });
}

const error = function (error) {
    pushData({
        'event': 'trackErrorPageV',
        'flow': 'paywall-v2',
        'errorType': error,
        'errorPage': true
    })
}

const trackCustomDimension = function (data) {
    pushData(data);
}



const trackABTesting = function (experimentId, variant) {
    try {
        (function () {
            if ((typeof ga !== 'undefined')
                && (typeof ga === 'function')
                && ga.loaded
                && ga.getAll()
                && ga.getAll()[0]
                && ga.getAll()[0].get
                && ga.getAll()[0].get('name')) {
                console.log('GA_LOADED', ga.loaded);
                let tracker = ga.getAll()[0].get('name');
                console.log('TRACKER', tracker);
                ga(`${tracker}.set`, 'exp', `${experimentId}.${variant}`);
                console.log(`${tracker}.set`, 'exp', `${experimentId}.${variant}`);
                ga(`${tracker}.send`, 'event', 'Experiment', 'Trigger', `${experimentId}.${variant}`, { nonInteraction: true });
                console.log(`${tracker}.send`, 'event', 'Experiment', 'Trigger', `${experimentId}.${variant}`, { nonInteraction: true });
                //codigo viejo
                //ga('set', 'exp', `${experimentId}.${variant}`);
                //ga('send', 'pageview');
            }
            else {
                console.log('wait, set timeout en 1000');
                setTimeout(() => {
                    trackABTesting(experimentId, variant);
                }, 1000);
            }
        })();

    }
    catch (e) {
        console.log('ERROR', e);
    }
}

const pushData = function (data) {
    if ((typeof dataLayer !== 'undefined') && dataLayer) {
        dataLayer.push(data)
    }
    else {
        model.Window.datalerPushes.push(data);
    }
}

const pushDelayed = function (data) {
    if ((typeof dataLayer !== 'undefined') && dataLayer) {
        model.Window.datalerPushes.forEach(element => {
            dataLayer.push(element)
        });
    }
}

const getGoogleTransactionPayload = function (name, price, sku) {
    return ({
        'event': 'trackTransaction',
        'name': name,  // Indicará un string con el nombre del paquete, por ejemplo: Acceso Digital     
        'price': price, // Valor de la suscripción
        'started': model.Window.lastFlow, // Indicará con un string la letra del flujo por el cual inició. Por ejemplo: B
        'article': model.Window.paginaId ? model.Window.paginaId : "",
        'sku': sku,
        'category': model.ProductCategory,
        'brand': model.Embed.Mobile ? "App Android" : "Web"
    })
}

const buttonsTracker = function(invoker){
    const eventData = {
        'event': 'e_linkclick',
        'dynamic_action': model.Window.source,
        'dynamic_category':'click',
        'dynamic_label': invoker
    };

    dataLayer.push(eventData);
}

export default {
    otrosEnlaces,
    clickCombo,
    clickCombo3,
    clickYaTengoSuscripcion,
    trackViewPaywall,
    trackCustomDimension,
    pushDelayed,
    paginaVirtual,
    error,
    trackABTesting,
    getGoogleTransactionPayload,
    trackViewLanding,
    clearEcommerce,
    buttonsTracker
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/analytics.js